import {
  getCurrentProfileSelect,
  PROFILE_INTEREST_FOCUS,
  PROFILE_KEY
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { createSelector } from 'reselect'

export const getInterestFocusProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => (
    getValueReduxUtil(profile, PROFILE_KEY.INTEREST_FOCUS)
  )
)

export const isInterestedInWorkoutsProfileSelect = createSelector(
  getInterestFocusProfileSelect,
  (interestFocus) => !interestFocus || [
    PROFILE_INTEREST_FOCUS.WORKOUTS,
    PROFILE_INTEREST_FOCUS.BOTH
  ].includes(interestFocus)
)

export const isInterestedInNutritionProfileSelect = createSelector(
  getInterestFocusProfileSelect,
  (interestFocus) => !interestFocus || [
    PROFILE_INTEREST_FOCUS.NUTRITION,
    PROFILE_INTEREST_FOCUS.BOTH
  ].includes(interestFocus)
)

export const isOnlyInterestedInNutritionProfileSelect = createSelector(
  isInterestedInWorkoutsProfileSelect,
  (isInterestedInWorkouts) => !isInterestedInWorkouts
)
